import { Lang } from 'vuejs-localization';
import { IPrizeElement, IPrizeStake } from '@/components/game/implementations/_default/_domain/models';
import { ILocalisationService, LocalisationService } from '@/app-modules/localisation-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { container } from '@/app-modules/_ioc';

class PrizeHelper {
  private localisationService: ILocalisationService;
  private $lang: Lang;

  constructor() {
      this.localisationService = container.get(SERVICE_IDENTIFIERS.ILocalisationService) as ILocalisationService;
      this.$lang = this.localisationService.getLangInstance();
  }

  public formatPrize(prizeValueInPenceOrPrizeElement: number | IPrizeElement): string {
    let prizeValueInPence: number;
    let minimumFractionDigits: number = 2;
    if (typeof prizeValueInPenceOrPrizeElement === 'number') {
      prizeValueInPence = prizeValueInPenceOrPrizeElement;
    }
    else {
      prizeValueInPence = prizeValueInPenceOrPrizeElement.prize;
      if (prizeValueInPenceOrPrizeElement.isJackpot) {
        minimumFractionDigits = 0;
      }
    }

    return this.formatCurrency(prizeValueInPence, minimumFractionDigits);
  }

  public formatStake(stakeValueInPenceOrPrizeStake: number | IPrizeStake): string {
    let stakeValueInPence: number;
    const currencySymbolForPennies = this.$lang.game.prize.currencySymbolForPennies;
    if (typeof stakeValueInPenceOrPrizeStake === 'number') {
      stakeValueInPence = stakeValueInPenceOrPrizeStake;
    }
    else {
      stakeValueInPence = stakeValueInPenceOrPrizeStake.stakeValue;
    }

    if (stakeValueInPence >= 100) {
      return this.formatCurrency(stakeValueInPence);
    }
    return `${stakeValueInPence}` + `${currencySymbolForPennies}`;
  }

  private formatCurrency(currencyValueInPence: number, minimumFractionDigits: number = 2): string {
    const currencySymbol = this.$lang.game.prize.currencySymbol;
    // Euro countries have the currency symbol after amount
    if (currencySymbol === '€' || currencySymbol === 'kr') {
      return `${(currencyValueInPence / 100).toLocaleString(undefined, { minimumFractionDigits })}${currencySymbol}`;
    }
    return `${currencySymbol}${(currencyValueInPence / 100).toLocaleString(undefined, { minimumFractionDigits })}`;
  }
}

export { PrizeHelper };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/helpers/prize-helper.ts